export default {"src":"/_next/static/media/ico_info.0eba3ef7.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};